import { cryptoInstance } from '@/public/fetch/index';
import { exercisePath } from '@/public/utils/basePath';
const baseURL = `${exercisePath}/exercise`;
const baseConfig = {
    baseURL
};
export const getRankList = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/exercise/ranking', con);
};
export const getExerciseCalendar = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/exercise/calendar', con);
};
export const getExerciseList = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/exercise/list', con);
};
export const getExerciseData = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/exercise/statistics', con);
};
export const getExerciseHot = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/exercise/hot', con);
};
export const getExerciseReport = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/report/detail', con);
};
export const getOtherQuestionList = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/dialog/others/list', con);
};
export const getMyQuestionList = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/dialog/mine/list', con);
};
export const getQuestionDetail = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/dialog/detail', con);
};
export const getExpertReplyList = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/dialog/expert/mine/list', con);
};
export const getExpertAllList = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/dialog/expert/all/list', con);
};
// 一级评论列表
export const getDialogRemarkList = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/dialog/remark/list', con);
};
// 二级评论列表
export const getRemarkMessageList = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/dialog/remark/detail', con);
};
// 文章详情
export const getArticleDetail = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get('/article/detail', con);
};
export const postFinishTask = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post('/progress/save', params, con);
};
/**
 * 查看题目
 * @query
 * taskId
 * paperId
 */
export const getTask = (query, config) => {
    let con = Object.assign({}, { baseURL, params: query }, config);
    return cryptoInstance.get(`/quiz/next`, con);
};
// 答题状态
export const getCheck = (query, config) => {
    let con = Object.assign({}, { baseURL, params: query }, config);
    return cryptoInstance.get(`/quiz/check`, con);
};
// 答题状态-未开始
export const getStart = (query, config) => {
    let con = Object.assign({}, { baseURL, params: query }, config);
    return cryptoInstance.get(`/quiz/start`, con);
};
// 上一题
export const getPrevious = (query, config) => {
    let con = Object.assign({}, { baseURL, params: query }, config);
    return cryptoInstance.get(`/quiz/previous`, con);
};
// 提交
export const getAnswer = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post(`/quiz/answer`, params, con);
};
// 最后一题结果
export const getResult = (query, config) => {
    let con = Object.assign({}, { baseURL, params: query }, config);
    return cryptoInstance.get(`/quiz/result`, con);
};
// 收藏
export const getCollect = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post('/bookmark/add', params, con);
};
// 取消收藏
export const getUncollect = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post('/bookmark/remove', params, con);
};
// APP 首页习题展示
export const getHome = (params, config) => {
    let con = Object.assign({}, { baseURL, params }, config);
    return cryptoInstance.get(`/home/question/latest`, con);
};
export const postAddStudyTarget = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post('/objective/user/add', params, con);
};
export const postAddQuiz = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post('dialog/user/add', params, con);
};
// 一级评论
export const postAddRemark = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post('/remark/add', params, con);
};
// 二级评论
export const postAddRemarkMessage = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post('/message/add', params, con);
};
// 三级评论
export const postAddNag = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post('/nag/add', params, con);
};
// 评论点赞
export const postRemarkLike = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.post('/approval/toggle', params, con);
};
/**
 * @data
 * quizId
 * questionId
 * answer: {
 *  A: true,
 *  B: false
 * }
 */
export const postAnswer = data => {
    return cryptoInstance.post('/exercise/quiz/answer', data);
};
/**
 * 获取智能练习列表
 *
 */
export const getExerciseListInfo = (params) => {
    return cryptoInstance.get(`/exercise/available`, {
        params,
        baseURL
    });
};
// 练习专辑详情
export const getExerciseDetail = (query) => {
    return cryptoInstance.get(`/exercise/detail`, {
        baseURL,
        params: query
    });
};
// 试卷分享页详情
export const getShareQuizDetail = (query) => {
    return cryptoInstance.get(`/quiz/share/question/detail`, {
        baseURL,
        params: query
    });
};
// 判断用户是否能做题
export const getCheckPaper = (query) => {
    return cryptoInstance.get(`/exercise/check`, {
        baseURL,
        params: query
    });
};
// 试卷收藏
export const paperFav = (data) => {
    return cryptoInstance.post(`/bookmark/paper/add`, data, {
        baseURL
    });
};
// 试卷取消收藏
export const cancelPaperFav = (data) => {
    return cryptoInstance.post(`/bookmark/remove`, data, {
        baseURL
    });
};
// 病例练习推荐
export const recommendedMedicase = (params) => {
    return cryptoInstance.get(`/medicase/recommended`, {
        baseURL,
        params
    });
};
// 热门病例
export const hotMedicase = (params) => {
    return cryptoInstance.get(`/medicase/hot`, {
        baseURL,
        params
    });
};
// 病例练习用户标签
export const userTagList = (query) => {
    return cryptoInstance.get(`/medicase/user/tag/list`, {
        baseURL,
        params: query
    });
};
// 添加用户兴趣标签
export const addUserTag = (data) => {
    return cryptoInstance.post(`/medicase/user/tag/add`, data, {
        baseURL
    });
};
// 用户病例练习会员状态
export const userMedicaseOverview = (query) => {
    return cryptoInstance.get(`/medicase/overview`, {
        params: query,
        baseURL
    });
};
// 用户病例练习记录
export const userHistory = (params) => {
    return cryptoInstance.get(`/medicase/history`, {
        baseURL,
        params
    });
};
// 练习报告
export const userReport = (params) => {
    return cryptoInstance.get(`/medicase/report`, {
        baseURL,
        params
    });
};
// 用户反馈
export const userFeedback = (data) => {
    return cryptoInstance.post(`/quiz/feedback`, data, {
        baseURL
    });
};
// 热门病例
export const searchMedicase = (params) => {
    return cryptoInstance.get(`/medicase/search`, {
        baseURL,
        params
    });
};
// omo 兑换
export const getExchangeTicket = (params) => {
    return cryptoInstance.get(`/card/exchange/init`, {
        baseURL,
        params
    });
};
// 兑换门票
export const cardExchange = (data) => {
    return cryptoInstance.post(`/card/exchange`, data, { baseURL });
};
// 练习卡兑换判断
export const exhangeCheck = (params) => {
    return cryptoInstance.get(`/card/exchange/check`, {
        baseURL,
        params
    });
};
// 令牌-搜索用户令牌 /exercise/user/token/search?page=1
export const tokenSearch = (params) => {
    return cryptoInstance.get(`/user/token/search`, {
        baseURL,
        params
    });
};
// 令牌-删除令牌
export const tokenKick = (data) => {
    return cryptoInstance.post(`/user/token/kick`, data, { baseURL });
};
// 令牌-登录日志
export const tokenHistory = (params) => {
    return cryptoInstance.get(`/user/token/history`, {
        baseURL,
        params
    });
};
